import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./entity-header.module.scss";

export interface IEntityHeader {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EntityHeader = (props: IEntityHeader) => {
  return (
    <div className={cx(styles.entity_header, "entity-header", props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

EntityHeader.defaultProps = {};
